import React, { useState } from "react";
import styled from "styled-components";
import { AdminButton } from "../../pages/admin/action_engine";

import CreateUserPanel from "./CreateUserPanel";
import { createUser } from "../../services/adminApi";
import logger from "../../utils/logger";

export default function CreateUserPanelContainer() {
  const [serverMessage, setServerMessage] = useState("");
  const [serverError, setServerError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [justCreatedLogin, setJustCreatedLogin] = useState("");
  const [formKey, setFormKey] = useState(0);

  const handleCreateUser = async (formData) => {
    setServerMessage("");
    setServerError(false);

    try {
      const { data } = await createUser(formData);

      if (data) {
        setJustCreatedLogin(data.username);
        setShowModal(true);
        setServerMessage(data.message || "Utilisateur créé avec succès.");
        setServerError(false);
        setFormKey((prev) => prev + 1);
      } else {
        setServerError(true);
        setServerMessage("Erreur lors de la création.");
      }
    } catch (err) {
      logger.error(err);
      setServerError(true);
      setServerMessage(
        err?.response?.data?.error ||
          err?.response?.data?.detail ||
          err?.response?.data?.msg ||
          "Impossible de contacter le serveur."
      );
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setServerMessage("");
    setServerError(false);
    setJustCreatedLogin("");
    setFormKey((prev) => prev + 1);
  };

  return (
    <>
      {serverMessage && (
        <PanelMessage $error={serverError}>
          {serverMessage}
        </PanelMessage>
      )}

      <CreateUserPanel
        key={formKey}
        variant="sidePanel"
        onSubmit={handleCreateUser}
      />

      {showModal && (
        <Modal onClose={handleModalClose}>
          <ModalContent>
            <ModalTitle>Utilisateur créé avec succès 🎉</ModalTitle>

            <ModalText>
              Identifiant : <strong>{justCreatedLogin}</strong>
            </ModalText>

            <ModalText>
              Un e-mail a été envoyé à cet utilisateur pour définir son mot de passe.
            </ModalText>

            <div style={{ display: "flex", gap: "1rem", marginTop: "1.5rem" }}>
              <ModalButton
                type="button"
                onClick={handleModalClose}
              >
                Terminer
              </ModalButton>
            </div>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}

const PanelMessage = styled.div`
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
  border-radius: 14px;
  background: ${({ $error }) => ($error ? "#ffe8e8" : "#e8fff1")};
  color: ${({ $error }) => ($error ? "#8a1f1f" : "#0f5d35")};
  font-weight: 800;
`;

const Modal = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(8, 13, 26, 0.68);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
`;

const ModalContent = styled.div`
  width: min(460px, 100%);
  border-radius: 24px;
  background: #fff9ea;
  color: #0b1328;
  padding: 2rem;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.3);
`;

const ModalTitle = styled.h3`
  margin: 0 0 1rem;
  font-size: 1.5rem;
  font-weight: 950;
`;

const ModalText = styled.p`
  margin: 0.5rem 0;
  line-height: 1.5;
`;

const ModalButton = styled(AdminButton)`
  border: none;
  border-radius: 999px;
  padding: 0.85rem 1.4rem;
  background: #0b1328;
  color: #fff9ea;
  font-weight: 900;

  &:not(:disabled):hover {
    background: #16213d;
  }

  &:not(:disabled):active {
    background: #080f20;
  }
`;
